import { render, staticRenderFns } from "./SalesMan.vue?vue&type=template&id=46bfdf2c&"
import script from "./SalesMan.vue?vue&type=script&lang=js&"
export * from "./SalesMan.vue?vue&type=script&lang=js&"
import style0 from "./SalesMan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports